import React from "react";
import "../Style/Hero.css";

const RIBBON_A = ["Pages", "Profiles", "Products", "Portfolios", "Shops", "Playlists", "Videos", "Bookings"];
const RIBBON_B = ["One link", "Every platform", "Your brand", "Live in minutes", "Share anywhere", "Made to stand out"];

// The list is repeated four times so the loop never shows a gap, even on
// very wide screens. The CSS moves the track by exactly half its width.
function Ribbon({ items, variant }) {
  const half = [...items, ...items];
  const row = [...half, ...half];
  return (
    <div className={`hero-ribbon hero-ribbon--${variant}`}>
      <div className="hero-ribbon-track">
        {row.map((text, i) => (
          <span className="hero-ribbon-item" key={i}>
            {text}
            <span className="hero-ribbon-star">&#10022;</span>
          </span>
        ))}
      </div>
    </div>
  );
}

function Hero({ onOpenAuth }) {
  return (
    <section className="hero">
      <div className="hero-bg" aria-hidden="true">
        <span className="hero-ring hero-ring--1" />
        <span className="hero-ring hero-ring--2" />
        <span className="hero-ring hero-ring--3" />
        <span className="hero-ring hero-ring--4" />
        <span className="hero-glow" />
      </div>

      <div className="hero-badge" aria-hidden="true">
        <svg className="hero-badge-svg" viewBox="0 0 200 200">
          <defs>
            <path
              id="hero-badge-circle"
              d="M 100,100 m -76,0 a 76,76 0 1,1 152,0 a 76,76 0 1,1 -152,0"
            />
          </defs>
          <text>
            <textPath href="#hero-badge-circle" textLength="468" lengthAdjust="spacing">
              ONE LINK • EVERYTHING YOU CREATE •
            </textPath>
          </text>
        </svg>
        <span className="hero-badge-core">&#8599;</span>
      </div>

      <div className="hero-inner">
        <span className="hero-eyebrow">
          <span className="hero-eyebrow-dot" />
          MLink
        </span>

        <h1 className="hero-title">
          One link for <em>everything</em> you create
        </h1>

        <p className="hero-subtitle">
          Pages, profiles and products, all in a single beautifully simple
          place.
        </p>

        <div className="hero-actions">
          <button
            type="button"
            className="hero-btn hero-btn-primary"
            onClick={() => onOpenAuth("signup")}
          >
            Get Started
            <span className="hero-btn-arrow" aria-hidden="true">
              &rarr;
            </span>
          </button>

          <a href="#how-it-works" className="hero-btn hero-btn-secondary">
            How It Works
          </a>
        </div>

        <div className="hero-url" aria-hidden="true">
          <span className="hero-url-base">mlink.com/</span>
          <span className="hero-url-name">yourname</span>
          <span className="hero-url-caret" />
        </div>
      </div>

      <div className="hero-ribbons" aria-hidden="true">
        <Ribbon items={RIBBON_A} variant="a" />
        <Ribbon items={RIBBON_B} variant="b" />
      </div>
    </section>
  );
}

export default Hero;